<template>
  <v-container fluid>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="mb-3">
      <el-breadcrumb-item :to="{ path: '/' }">แดชบอร์ด</el-breadcrumb-item>
      <el-breadcrumb-item>พนักงานส่งของ</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="mt-3">
      <v-data-table
        :headers="headers"
        :items="driverList"
        :pagination.sync="pagination"
        :loading="isLoading"
        class="elevation-0"
      >
        <template v-slot:no-data>
          <div class="text-xs-center">ไม่มีพนักงานส่งของ</div>
        </template>
        <template v-slot:items="props">
          <tr>
            <td class="text-xs-left">{{props.item.driver_id}}</td>
            <td class="text-xs-left">
              <div
                v-if="props.item.status=='available'"
                class="green lighten-1 badge-status"
              >พร้อมรับงาน</div>
              <div v-if="props.item.status=='ongoing'" class="purple badge-status">กำลังทำงาน</div>
            </td>
            <td
              class="text-xs-left"
            >{{props.item.user_info.firstname}} {{props.item.user_info.lastname}}</td>
            <td class="text-xs-left">{{props.item.user_info.mobile}}</td>
            <td class="text-xs-left">{{props.item.user_info.email}}</td>
            <td class="text-xs-right">
              <el-button type="text" size="small" @click="openItem(props.item)">ดูรายละเอียด</el-button>
            </td>
          </tr>
        </template>
      </v-data-table>
    </el-card>

    <v-btn
      fab
      dark
      bottom
      right
      fixed
      color="primary"
      v-if="!addDriverDialog"
      @click="onAddDialog()"
    >
      <v-icon>fas fa-plus</v-icon>
    </v-btn>

    <v-dialog persistent v-model="addDriverDialog" scrollable max-width="600px">
      <v-card>
        <v-card-title>เพิ่มพนักงานส่งของ</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <el-form label-position="left" label-width="100px" @submit.native.prevent>
            <el-form-item label="ชื่อ">
              <el-input v-model="form.firstname"></el-input>
            </el-form-item>
            <el-form-item label="นามสกุล">
              <el-input v-model="form.lastname"></el-input>
            </el-form-item>
            <el-form-item label="อีเมล">
              <el-input v-model="form.email"></el-input>
            </el-form-item>
            <el-form-item label="เบอร์มือถือ">
              <el-input v-model="form.mobile"></el-input>
            </el-form-item>
            <el-form-item label="เพศ">
              <el-radio-group v-model="form.gender">
                <el-radio :label="`m`">ชาย</el-radio>
                <el-radio :label="`f`">หญิง</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="addDriverDialog = false">ปิด</v-btn>
          <v-btn color="red darken-2" flat @click="onSave">บันทึก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import Service from "../../services";
import moment from "moment";
import { mapState } from "vuex";

export default {
  components: {},
  props: [],
  data() {
    return {
      isLoading: false,
      loading: null,
      addDriverDialog: false,
      driverList: [],
      headers: [
        {
          text: "#",
          align: "left",
          sortable: false,
          value: ""
        },
        { text: "สถานะ", value: "", sortable: false },
        { text: "ชื่อ-นามสกุล", value: "", sortable: false },
        { text: "เบอร์มือถือ", value: "", sortable: false },
        { text: "อีเมล", value: "", sortable: false },
        { text: "", value: "", sortable: false }
      ],
      pagination: {
        rowsPerPage: -1
      },
      form: {
        firstname: "",
        lastname: "",
        email: "",
        mobile: "",
        gender: "m"
      }
    };
  },
  mounted() {},
  created() {
    Service.Driver.gets().then(res => {
      this.driverList = res.data;
    });
  },
  methods: {
    onAddDialog() {
      this.addDriverDialog = true;
    },
    onSave() {
      if (
        this.form.firstname == "" ||
        this.form.lastname == "" ||
        this.form.email == "" ||
        this.form.mobile == ""
      ) {
        this.$notify.error({
          title: "ผิดพลาด",
          message: "กรุณากรอกข้อมูลพนักงานส่งของให้ครบ"
        });
        return;
      }
      if (!this.isEmail(this.form.email)) {
        this.$notify.error({
          title: "ผิดพลาด",
          message: "อีเมลไม่ถูกต้อง"
        });
        return;
      }
      if (!this.isPhoneNo(this.form.mobile)) {
        this.$notify.error({
          title: "ผิดพลาด",
          message: "เบอร์มือถือไม่ถูกต้อง"
        });
        return;
      }

      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)"
      });

      Service.Driver.create(this.form).then(res => {
        if (res.success) {
          this.form = {
            firstname: "",
            lastname: "",
            email: "",
            mobile: "",
            gender: "m"
          };
          this.addDriverDialog = false;
        }
        this.loading.close();
      });
    },
    openItem(item) {},
    isPhoneNo(input) {
      var regExp = /^0[0-9]{8,9}$/i;
      return regExp.test(input);
    },
    isEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  }
};
</script>